// ❗❗ any changes to any route should be considered in the middleware.ts file
// to keep public and guest only pages in sync with the routes

const constants = {
    adamWebsiteUrl: 'https://adam.ai',
    globalWebAppUrl: 'https://platform.adam.ai',
    ksaWebAppUrl: 'https://ksaplatform.adam.ai',
    adamWebsitePricingUrl: 'https://adam.ai/pricing',
    usersAdminPortalUrl: '/admin-portal/users',
    billingAdminPortalUrl: '/admin-portal/billing?tab=details',
    integrationsAdminPortalUrl: '/admin-portal/integrations',
    settingsAdminPortalUrl: '/admin-portal/settings',
    homepageUrl: '/home',
    meetingPageUrl: '/meetings',
    actionPage: '/actions',
    spacesPage: '/spaces',
    marketplacePageUrl: '/marketplace',
    settingsUrl: '/settings',
    meetingRoomUrl: '/meetings/room?meetingId=',
    teamsAddonMarketplaceUrl:
        'https://appsource.microsoft.com/en-us/product/office/WA200001542?tab=Overview',
    teamsMeetingRoomUrl: '/teams-addon/meeting-room?meetingId=',
    zoomMeetingRoomUrl: '/third-party-apps/zoom/meeting-room?meetingId=',
    downloadAttachmentUrl: '/meetings/download-attachment',
    meetingMinutesUrl: '/meetings/meeting-minutes',
    meetingMinutesCycle: {
        approvedUrl: '/meetings/approved-meeting-minutes',
        rejectedUrl: '/meetings/rejected-meeting-minutes',
        pendingUrl: '/meetings/pending-meeting-minutes',
        approversPage: '/meetings/minutes-approvers',
    },
    spaceDashboardUrl: '/spaces/dashboard?spaceId=',
    signupUrl: 'https://adam.ai/request-a-demo',
    requestADemoUrl: 'https://adam.ai/request-a-demo',
    signupUrlRefToken: 'a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8',
    signInViaNafathUrl: '/signin-nafath',
    signUpViaNafathUrl: '/signup-nafath',
    approveSignInViaNafathRequestUrl: '/signin-nafath/approve-sign-in-request',
    signInUrl: '/signin',
    joinMeetingWithAccessCodeUrl:
        '/meetings/JoinMeetingWithAccessCodePage?meetingId=',
    universalSearchUrl: '/search',
    verifyMeetplaceUrl: '/verify-meetplace',
    helpCenterUrl:
        'https://adamdotai.atlassian.net/servicedesk/customer/portal/3',
    baseUrl: 'https://v4.adamdotaidev.space',
    actionUrl: '/actions?mainTab=allActions&listTab=all&id=',
    adamMobileApp:
        'https://deeplinks.adam.ai/?apn=com.adamdotai.app&ibi=com.adamdotai.app&isi=1661458659&efr=1&link=',
    teamsJoinCallBase: 'https://teams.microsoft.com/l/meetup-join',
    storage: {
        recentColors: {
            text: 'recentTextColors',
            background: 'recentBgColors',
        },
        analyticsDateFilter: 'analyticsDateFilter',
        analyticsDateRange: 'analyticsDateRange',
        selectedRegion: 'selectedRegion',
        recentSearches: 'recentSearches',
        hideFacilitatorChangeConfirmationKey:
            'meetingroom.hideFacilitatorChangeConfirmation',
        hideChairChangeConfirmationKey:
            'meetingroom.hideChairChangeConfirmation',
    },
    codes: {
        resetSuccess: 'resetSuccess',
        invalidCode: 'invalidCode',
        userExists: 'userExists',
        invalidInvitation: 'invalidInvitation',
        invalidConfirmation: 'invalidConfirmation',
        expiredConfirmation: 'expiredConfirmation',
        invalidInvitedEmail: 'invalidInvitedEmail',
    },
    maxLength: {
        hashtagMention: 40,
        title: 50,
        short: 100,
        normal: 255,
    },
    featureFlags: {
        signup: 'signup',
        groups: 'groups',
        subdirectory: 'settings_subdirectory',
        adamVideoConference: 'video-conferencing',
        adamVideoConferenceJAAS: 'video-conferencing-jaas',
        booking: 'booking',
        aiAssistant: 'ai_assistant',
        advancedSupport: 'advanced-support',
        customApi: 'custom-api',
        additionalStorage: 'additional-storage',
        aiPrompts: 'meetingroom_ai-prompts',
        ai: 'ai',
        meetingMinutes: 'meeting-minutes',
        systemLog: 'settings_activitylogs',
        exchangeCalendar: 'integrations_exchange-calendar',
        googleCalendar: 'integrations_google-calendar',
        microsoftCalendar: 'integrations_microsoft-calendar',
        arabicLanguage: 'arabic-language',
        meetingMinutesApproval: 'meeting-minutes-approval',
        actionDelegate: 'action-delegate',
        documentAnnotation: 'document-annotation',
        integrationsCalendarForwarding: 'integrations_calendar-forwarding',
        integrationsCalendarOneWaySync: 'integrations_calendar-one-way-sync',
        spaceManageMemberMeetings: 'space_manage-member-meetings',
        advancedBranding: 'advanced-branding',
        advancedIntegrations: 'advanced-integrations',
        authenticationSSO: 'integrations_sso',
        renameSpaceMember: 'space_rename_member',
        documentAprysePreviewer: 'document_apryse-previewer',
        aiCapture: 'ai_ai-capture',
        chatbot: 'ai_chatbot',
        gdpr: 'gdpr-feature',
        meetingAttendeeSyncError: 'meeting-attendee-sync-error',
        actionActivityTracking: 'action-activity-tracking',
        ssoLogin: 'sso-login',
        nafath: 'nafath',
        credentialLogin: 'credential-login',
        thirdPartyLogin: 'thirdparty-login',
        regionSelector: 'region-selector',
        tracking: 'tracking',
        actionWatchers: 'action-watchers',
        entraId: 'entra-id',
        adminPortalBilling: 'admin-portal-billing',
        iAdamAssistant: 'i-adam-assistant',
        jiraIntegration: 'jira-integration',
        administrativeIntegrations: 'administrative-integrations',
        upgrade: 'upgrade',
        analytics: 'analytics',
        ldap: 'ldap',
        scotBranding: 'scot-branding',
        aiRecap: 'ai-recap',
        momahDemo: 'momah-demo',
        landingChangeLanguage: 'landing-change-language',
        aprysJSBackend: 'aprys-js-backend',
        iAdamRecordings: 'i-adam-recordings',
        mobileBanners: 'mobile-banners',
        brandingConfig: 'branding-config',
        downloadMomWord: 'download-mom-word',
        eSignScot: 'e-sign-scot',
        meetingAttendanceMomah: 'meeting-attendance-momah',
    },
    roles: {
        meetplaceOwner: 'd91984e1-e51e-4766-8a7f-d134d14c70c6',
        meetplaceAdmin: '113267e0-08f3-4224-8d39-60f891e3fac6',
        meetplaceMember: 'a8ebbdec-5924-4290-b2a4-4b91ab985d80',
        meetplaceGuest: 'e0306612-78a8-4636-8422-7eb1caa474f9',
        groupOwner: '51249bba-024f-4762-a2b8-0dad83c01e08',
        groupEditorOwner: '3f9d08e7-2611-49de-a3aa-d8768084a485',
    },
    saasEnvironments: {
        GLOBAL: 'GLOBAL',
        KSA: 'KSA',
    },
    adamAssistant: {
        noResultFound: 'No result found',
        noAgendaFound: 'No agenda found',
        noActionsFound: 'No actions found',
    },
    trackedEvents: {
        startAICapture: 'Start AI Capture',
        activateAICapture: 'Activate AI Capture',
        regenerateSummary: 'Regenerate Summary',
        addAllToNotes: 'Add All To Notes',
        replaceNotes: 'Replace Notes',
        playRecording: 'Play Recording',
        deleteRecording: 'Delete Recording',
        editRecording: 'Edit Recording',
        recordingUploaded: 'Recording Uploaded',
        uploadRecordingButton: 'Upload Recording Button',
        minutesApprovals: 'Minutes Approvals',
        requestApproval: 'Request Approval',
        addAgendaItem: 'Add Agenda Item',
        uploadAttachment: 'Upload Attachment',
        attachmentUploaded: 'Attachment Uploaded',
        editor: 'Editor',
        participant: 'Participant',
        inviteAttendeesViaMeetingHeader: 'Invite Attendees Via Meeting Header',
        inviteButtonMeetingHeader: 'Invite Button Meeting Header',
        profilePhotoViaTopNavbar: 'Profile Photo Via Top Navbar',
        manageBookingOptionViaProfileMenu:
            'Manage Booking Option Via ProfileMenu',
        helpCenterOptionViaProfileMenu: 'Help Center Option Via ProfileMenu',
        adminPortalOptionViaProfileMenu: 'Admin Portal Option Via ProfileMenu',
        signOutOptionViaProfileMenu: 'Sign Out Option Via ProfileMenu',
        joinMeetingGuestViaAccessModal: 'Join Meeting Via Guest Access Modal',
        showCompletedActions: 'Show Completed Actions',
        addSubActionViaActionQuickViewOfActionsPage:
            'Add Sub-Action Via Action Quick View Of Actions Page',
        addAttachmentViaActionQuickViewOfActionsPage:
            'Add Attachment Via Action Quick View Of Actions Page',
        linkActionToAnItemViaActionQuickViewOfActionsPage:
            'Link Action To An Item Via Action Quick View Of Actions Page',
        relatedTabActionQuickView: 'Related Tab Action Quick View',
        commentsTabActionQuickView: 'Comments Tab Action Quick View',
        tagsTabActionQuickView: 'Tags Tab Action Quick View',
        showCompletedMeetings: 'Show Completed Meetings - Actions more options',
        showDeclinedMeetings: 'Show declined meetings',
        showCanceledMeetings: 'Show Canceled meetings',
        showArchivedMeetings: 'Show Archived meetings',
        selectMeetingCardViaMeetingsPage:
            'Select Meeting Card Via Meetings Page',
        allActionsFilterSpaceDashboardPage:
            'All Actions Filter Space Dashboard Page',
        myActionsFilterSpaceDashboardPage:
            'My Actions Filter Space Dashboard Page',
        starredFilterSpaceDashboardPage: 'Starred Filter Space Dashboard Page',
        includeAllArchivedSpaces: 'Include All Archived Spaces',
        includeAllStarredSpaces: 'Include All Starred Spaces',
        editSpaceCardMoreOptions: 'Edit - Space Card More Options',
        duplicateSpaceCardMoreOptions: 'Duplicate - Space Card More Options',
        copyLinkSpaceCardMoreOptions: 'Copy Link - Space Card More Options',
        createMeetingSpaceCardMoreOptions:
            'Create Meeting - Space Card More Options',
        transferOwnershipSpaceCardMoreOptions:
            'Transfer ownership - Space Card More Options',
        archiveSpaceCardMoreOptions: 'Archive - Space Card More Options',
        deleteSpaceCardMoreOptions: 'Delete - Space Card More Options',
        moreOptionsSpaceCard: 'More Options Space Card',
        showMoreViaStarredHomePage: 'Show more via starred Home page',
        showMoreViaActionsHomePage: 'Show more via actions Home page',
        showMoreViaPendingItemsHomePage:
            'Show more via Pending Items Home page',
        filterByAllMyActionsHomePage: 'Filter by All My Actions Home page',
        filterByTodayMyActionsHomePage: 'Filter by Today My Actions Home page',
        filterByThisWeekMyActionsHomePage:
            'Filter by This Week My Actions Home page',
        filterByThisMonthMyActionsHomePage:
            'Filter by This Month My Actions Home page',
        filterByAllMyPendingItemsHomePage:
            'Filter by All My Pending Items Home page',
        filterByTodayMyPendingItemsHomePage:
            'Filter by Today My Pending Items Home page',
        filterByThisWeekMyPendingItemsHomePage:
            'Filter by This Week My Pending Items Home page',
        filterByThisMonthMyPendingItemsHomePage:
            'Filter by This Month My Pending Items Home page',
        filterByAllStarredHomePage: 'Filter by All starred Home page',
        filterBySpacesStarredHomePage: 'Filter by Spaces starred Home page',
        filterByMeetingsStarredHomePage: 'Filter by Meetings starred Home page',
        filterByActionsStarredHomePage: 'Filter by Actions starred Home page',
        connectYourCalendarViaHomePage: 'Connect your calendar  via home page',
        createMeetingViaHomePage: 'Create Meeting via home page',
        customizeHomePage: 'Customize Home Page',
        viewAllMyMeetings: 'View all my meetings',
        viewMeetingDetailsViaHomePage: 'View meeting details via home page',
        viewMeetingViaHomePage: 'View meeting via home page',
        toDoTabActionsHomePage: 'To Do Tab Actions Widget Home Page',
        overdueTabActionsHomePage: 'Overdue Tab Actions Widget Home Page',
        completedTabActionsHomePage: 'Completed Tab Actions Widget Home Page',
        delegateByYouTabActionsHomePage:
            'Delegate by you Tab Actions Widget Home Page',
        minutesTabPendingItemsWidgetHomePage:
            'Minutes Tab Pending Items Widget Home Page',
        pollsTabPendingItemsWidgetHomePage:
            'Polls Tab Pending Items Widget Home Page',
        overviewTabViaSpaceDashboard: 'Overview Tab Via Space Dashboard',
        membersTabViaSpaceDashboard: 'Members Tab Via Space Dashboard',
        upcomingTabViaSpaceDashboard: 'Meetings Tab Via Space Dashboard',
        actionsTabViaSpaceDashboard: 'Actions Tab Via Space Dashboard',
        decisionsTabViaSpaceDashboard: 'Decisions Tab Via Space Dashboard',
        pollsTabViaSpaceDashboard: 'Polls Tab Via Space Dashboard',
        attachmentsTabViaSpaceDashboard: 'Attachments Tab Via Space Dashboard',
        allFilterActionsPage: 'All Filter Actions Page',
        actionsFilterActionsPage: 'Actions Filter Actions Page',
        subActionsFilterActionsPage: 'Sub Actions Filter Actions Page',
        delegatedFilterActionsPage: 'Delegated Filter Actions Page',
        createActionViaActionsPage: 'Create Action Via Actions Page',
        changeDueDateViaActionQuickView:
            'Change Due Date Via Action Quick View',
        groupActionsByNone: 'Group Actions By None',
        groupActionsByDueDate: 'Group Actions By DueDate',
        groupActionsByStatus: 'Group Actions By Status',
        changeActionStatusViaActionQuickView:
            'Change Action Status Via Action Quick View',
        starActionViaActionCardOfActionsPage:
            'Star Action Via Action Card Of Actions Page',
        markActionCompleteViaCheckboxInActionCardOfActionsPage:
            'Mark Action Complete Via Checkbox In Action Card Of Actions Page',
        selectActionDateViaActionCardInActionsPage:
            'Select Action Date Via Action Card In Actions Page',
        changeActionStatusViaActionCardInActionsPage:
            'Change Action Status Via Action Card In Actions Page',
        connectCalendar: 'Connect Calendar',
        disconnectCalendar: 'Disconnect Calendar',
        inviteUser: 'Invite User',
        connectZoomIntegration: 'Connect Zoom Integration',
        disconnectZoomIntegration: 'Disconnect Zoom Integration',
        configureZoomIntegration: 'Configure Zoom Integration',
        connectMeetIntegration: 'Connect Meet Integration',
        disconnectMeetIntegration: 'Disconnect Meet Integration',
        connectTeamsIntegration: 'Connect Teams Integration',
        disconnectTeamsIntegration: 'Disconnect Teams Integration',
        configureTeamsIntegration: 'Configure Teams Integration',
        connectConfluenceIntegration: 'Connect Confluence Integration',
        disconnectConfluenceIntegration: 'Disconnect Confluence Integration',
        connectJiraIntegration: 'Connect Jira Integration',
        disconnectJiraIntegration: 'Disconnect Jira Integration',
        manageBooking: 'Manage Booking',
        managePlans: 'Manage Plans',
        extendFreeTrial: 'Extend Free Trial',
        contactOwner: 'Contact Owner',
        renewPlan: 'Renew Plan',
        learnMoreAboutPricing:
            'Learn More About Pricing, Packaging and Add-ons.',
        comparePlansAndFeatures: 'Compare Plans And Features',
        commonlyAskedQuestions: 'Commonly Asked Questions',
        signOut: 'Sign Out',
        signUpViaEmail: 'Sign Up Via Email',
        signUpViaApple: 'Sign Up Via Apple',
        signUpViaGoogle: 'Sign Up Via Google',
        signUpViaMicrosoft: 'Sign Up Via Microsoft',
        signInViaEmail: 'Sign In Via Email',
        signInViaApple: 'Sign In Via Apple',
        signInViaGoogle: 'Sign In Via Google',
        signInViaMicrosoft: 'Sign In Via Microsoft',
        createBookingSchedule: 'Create Booking Schedule',
        scheduleMeeting: 'Schedule Meeting',
        duplicateMeeting: 'Duplicate Meeting',
        duplicateMeetingViaMeetingQuickView:
            'Duplicate Meeting Via Meeting Quick View',
        duplicateMeetingViaMeetingOptions:
            'Duplicate Meeting From Meeting Options',
        cancelMeetingViaMeetingQuickView:
            'Cancel Meeting Via Meeting Quick View',
        cancelMeetingViaMeetingOptions: 'Cancel Meeting Via Meeting Options',
        copyMeetingLinkViaQuickView: 'Copy Meeting Link Via Quick View',
        copyMeetingLinkViaMeetingCard: 'Copy Meeting Link Via Meeting Card',
        copyMeetingLinkViaMeetingOptions:
            'Copy Meeting Link Via Meeting Options',
        createQuickMeeting: 'Create Quick Meeting',
        linkMeetingToSpace: 'Link Meeting To Space',
        linkActionToSpace: 'Link Action To Space',
        linkMeetingToVideoConference: 'Link Meeting To Video Conference',
        syncCalendar: 'Sync Calendar',
        openEventLink: 'Open Event Link',
        addMeetingTag: 'Add Meeting Tag',
        addMeetingAttendees: 'Add Meeting Attendees',
        viewMeeting: 'View Meeting',
        viewMeetingViaCardClick: 'View Meeting via Card Click',
        editMeetingFromMeetingQuickView: 'Edit Meeting From Meeting Quick View',
        editMeetingViaMeetingOptions: 'Edit Meeting From Meeting Options',
        openMeetingsPageFromSideNavigator:
            'Open Meetings Page From Side Navigator',
        openMarketplacePageFromSideNavigator:
            'Open Marketplace Page From Side Navigator',
        openActionsPageFromSideNavigator:
            'Open Actions Page From Side Navigator',
        openSpacesPageFromSideNavigator: 'Open Spaces Page From Side Navigator',
        starMeeting: 'Star Meeting',
        unstarMeetingViaMeetingRoomHeader:
            'Unstar Meeting - Meeting room header',
        filterMeeting: 'Filter Meeting',
        viewStarredMeetings: 'View Starred Meetings',
        createMeetingTemplate: 'Create Meeting Template',
        previewMeetingTemplate: 'Preview Meeting Template',
        setTemplateAsDefault: 'Set Template As Default',
        duplicateTemplate: 'Duplicate Template',
        applyMeetingTemplate: 'Apply Meeting Template',
        saveAsMeetingTemplate: 'Save As Meeting Template',
        joinCall: 'Join Call',
        joinAdamAiCall: 'Join Call Adam',
        joinMeetingAdam: 'Join Meeting Adam',
        addMeetingContentAgenda: 'Add Meeting Content Agenda',
        addMeetingContentAction: 'Add Meeting Content Action',
        addMeetingContentPoll: 'Add Meeting Content Poll',
        addMeetingContentDecision: 'Add Meeting Content Decision',
        addMeetingContentAttachment: 'Add Meeting Content Attachment',
        reactOnMeetingContentItem: 'React On Meeting Content Item',
        mentionMeetingContentItem: 'Mention Meeting Content Item',
        commentOnMeetingContentItem: 'Comment On Meeting Content Item',
        tagOnMeetingContentItem: 'Tag On Meeting Content Item',
        linkMeetingContentItem: 'Link Meeting Content Item',
        openAddPrivateNotes: 'Open Add Private Notes',
        privateMeetingChat: 'Private Meeting Chat',
        publicMeetingChat: 'Public Meeting Chat',
        viewAllMeetingActions: 'View All Meeting Actions',
        viewAllMeetingAttachments: 'View All Meeting Documents',
        viewAllRecordingHighlights: 'View All Recording Highlights',
        transcribeMeetingRecording: 'Transcribe Meeting Recording',
        addSelectedTranscriptToContentItem:
            'Add Selected Transcript To Content Item',
        aiSummarizeMeetingRecording: 'Ai Summarize Meeting Recording',
        addRecordingAiSummaryToContentSpace:
            'Add Recording Ai Summary To Content Space',
        addSelectedAiSummaryToContentItem:
            'Add Selected Ai Summary To Content Item',
        aiContentPromptsSuggestAgenda: 'Ai Content Prompts Suggest Agenda',
        aiContentPromptsFindActions: 'Ai Content Prompts Find Actions',
        aiContentPromptsSummarize: 'Ai Content Prompts Summarize',
        aiContentPromptsImproveWriting: 'Ai Content Prompts Improve Writing',
        aiContentPromptsAiMeetingSummary:
            'Ai Content Prompts Ai Meeting Summary',
        completeAction: 'Mark Complete Action',
        addSubAction: 'Add Sub Action',
        filterActions: 'Filter Actions',
        starAction: 'Star Action',
        watchAction: 'Watch Action',
        StopWatchingAction: 'Stop Watching Action',
        addActionTag: 'Add Action Tag',
        createSpace: 'Create Space',
        viewSpaceDashboard: 'View Space Dashboard',
        filterSpaces: 'Filter Spaces',
        sortSpaces: 'Sort Spaces',
        sortAsListSpacesPage: 'Sort As List Spaces Page',
        viewAsTilesSpacesPage: 'View As Tiles Spaces Page',
        searchContentSystemWide: 'Search Content System Wide',
        openBilling: 'Open Billing',
        openHelpCenterViaSideNavbar: 'Open Help Center via Side Navbar',
        tryItFree: 'Try It Free',
        requestADemo: 'Request A Demo',
        assignAction: 'Assign Action',
        saveChangesAccount: 'Save Changes Account',
        saveChangesDisplay: 'Save Changes Display',
        saveChangesNotifications: 'Save Changes Notifications',
        saveChangesCalendar: 'Save Changes Calendar',
        uploadProfilePhoto: 'Upload Profile Photo',
        removeProfilePhoto: 'Remove Profile Photo',
        bookingPage: 'Booking Page',
        customizeTemplate: 'Customize Template',
        viewMeetingMinutes: 'View Meeting Minutes',
        downloadMeetingMinutes: 'Download Meeting Minutes',
        shareMeetingMinutes: 'Share Meeting Minutes',
        clickOnAdamDotAiLogo: 'Click on adam.ai logo',
        clickOnTopNavbarCreateButton: 'Click On Top Navbar Create Button',
        openSettingsPageFromSideNavigator:
            'Open Settings Page From Side Navigator',
        deactivateAccount: 'Deactivate Account',
        moreOptionsViaMeetingQuickView: 'More Options Via Meeting Quick View',
        addLocationViaMeetingQuickView: 'Add Location Via Meeting Quick View',
        addSpaceViaMeetingQuickView: 'Add Space Via Meeting Quick View',
        clickOnMyActionsTab: 'Click On My Actions Tab',
        clickOnAllActionsTab: 'Click On All Actions Tab',
        starredActions: 'Click on Starred Actions Button',
        clickOnSortActionsButton: 'Click On Sort Actions Tab',
        clickOnNoneSortActionOption: 'Sort Action Option None',
        clickOnDueDateSortActionOption: 'Sort Action Option Due Date',
        clickOnCreatedOnSortActionOption: 'Sort Action Option Created On',
        clickOnCompletedOnSortActionOption: 'Sort Action Option Completed On',
        exportCSV: 'Export CSV',
        deleteAction: 'Delete Action',
        clickOnAppsTab: 'Click On Apps Tab',
        clickOnTemplatesTab: 'Click On Templates Tab',
        accountTab: 'Click On Account Tab',
        displayTab: 'Click On Display Tab',
        notificationsTab: 'Click On Notifications Tab',
        calendarTab: 'Click On Calendar Tab',
        bookingTab: 'Click On Booking Tab',
        changePassword: 'Change Password',
        contactSupport: 'Contact Support',
        joinOurCommunity: 'Join Our Community',
        sideNavBarHomeButton: 'Side NavBar Home Button',
        openPollsPageFromSideNavigator: 'Open Polls Page From Side Navigator',
        openDecisionsFromSideNavigator: 'Open Decisions From Side Navigator',
        openAttachmentsFromSideNavigator:
            'Open Attachments From Side Navigator',
        openAnalyticsFromSideNavigator: 'Open Analytics From Side Navigator',
        sideNavigatorHelpAndSupport: 'Side Navigator Help And Support',
        spacesAllTab: 'Spaces All Tab',
        spacesProjectsTab: 'Spaces Projects Tab',
        meetingsUpcomingTab: 'Meetings Upcoming Tab',
        meetingsPastTab: 'Meetings Past Tab',
        editThisAndFollowingMeetings: 'Edit This And Following Meetings',
        editAllMeetingsInIheSeries: 'Edit all meetings in the series',
        eventLink: 'Event Link',
        meetingOptions: 'Meeting Options',
        showMeetingDetails: 'Show Meeting Details',
        removeAttendee: 'Remove Attendee',
        changeAttendeeRole: 'Change Attendee Role',
        openChat: 'Open Chat',
        clickToAddBlockBelow: 'Click To Add Block Below',
        editorViewMoreOptions: 'Editor View More Options',
        addToMeetings: 'Add To Meetings',
        removeFromSpace: 'Remove From Space',
        allPolls: 'All polls - Polls page',
        myPolls: 'My polls - Polls page',
        sortPolls: 'Sort polls - Polls page',
        filterPolls: 'Filter polls - Polls page',
        addVote: 'Add vote via Poll quick view of Polls page',
        itemDetailsSubTabs: {
            polls: {
                votes: 'Votes tab via Poll quick view of Polls page',
                comments: 'Comments tab via Poll quick view of Polls page',
                related: 'Related tab via Poll quick view of Polls page',
                tags: 'Tags tab via Poll quick view of Polls page',
            },
            decisions: {
                comments:
                    'Comments tab via Decision quick view of Decisions page',
                related:
                    'Related tab via Decision quick view of Decisions page',
                tags: 'Tags tab via Decision quick view of Decisions page',
            },
            attachments: {
                comments: 'Comments tab via File quick view of Files page',
                related: 'Related tab via File quick view of Files page',
                tags: 'Tags tab via File quick view of Files page',
            },
        },
        meetingItemDetailsSubTabs: {
            POLL: {
                votes: 'Votes tab via Poll quick view of Meeting Page',
                comments: 'Comments tab via Poll quick view of Meeting Page',
                related: 'Related tab via Poll quick view of Meeting Page',
                tags: 'Tags tab via Poll quick view of Meeting Page',
            },
            ATTACHMENT: {
                comments:
                    'Comments tab via Attachment quick view of Meeting Page',
                related:
                    'Related tab via Attachment quick view of Meeting Page',
                tags: 'Tags tab via Attachment quick view of Meeting Page',
            },
            AGENDA: {
                comments: 'Comments tab via Agenda quick view of Meeting Page',
                related: 'Related tab via Agenda quick view of Meeting Page',
                tags: 'Tags tab via Agenda quick view of Meeting Page',
            },
            DECISION: {
                comments:
                    'Comments tab via DECISION quick view of Meeting Page',
                related: 'Related tab via DECISION quick view of Meeting Page',
                tags: 'Tags tab via DECISION quick view of Meeting Page',
            },
            ACTION: {
                comments: 'Comments tab via Action quick view of Meeting Page',
                related: 'Related tab via Action quick view of Meeting Page',
                tags: 'Tags tab via Action quick view of Meeting Page',
                activity: 'Activity tab via Action quick view of Meeting Page',
            },
            NOTE: {
                comments: 'Comments tab via Note quick view of Meeting Page',
                related: 'Related tab via Note quick view of Meeting Page',
                tags: 'Tags tab via Note quick view of Meeting Page',
            },
        },
        viewItemDetails: {
            attachment: 'View Attachment Item Details via Meeting page',
            poll: 'View Poll Item Details via Meeting page',
            'agenda-container': 'View Agenda Item Details via Meeting page',
            'action-container': 'View Action Item Details via Meeting page',
            'section-title-container':
                'View Section title Item Details via Meeting page',
            'note-container': 'View Note Item Details via Meeting page',
            'decision-container': 'View decision Item Details via Meeting page',
            'table-container': 'View table Item Details via Meeting page',
            'list-item': 'View list Item Details via Meeting page',
        },
        allDecisions: 'All decisions - Decisions page',
        myDecisions: 'My decisions - Decisions page',
        sortDecisions: 'Sort decisions - Decisions page',
        filterDecisions: 'Filter decisions - Decisions page',
        allFiles: 'All files - Files page',
        myFiles: 'My files - Files page',
        sortFiles: 'Sort files - Files page',
        filterFiles: 'Filter files - Files page',
        viewFile: 'View File via file quick view of files page',
        moreOptionsViaFileQuickView:
            'More Options via file quick view of files page',
        downloadFileViaFileQuickView:
            'Download file via file quick view of files page',
        deleteFileViaFileQuickView:
            'Delete file via file quick view of files page',
        learnMore: 'Learn more via calendar tab of Setting page',
        profileLink: 'Booking Profile link',
        bookingEventLink: 'Booking Event Link via Booking Card',
        bookingSetting: 'Setting button via booking tab of setting page',
        availabilityBooking: 'Availability via booking tab of setting page',
        publicBookingLink: 'Public Booking Link',
        moreOptionsBookingCard: 'More Options booking card',
        editBooking: 'Edit booking via booking card',
        deleteBooking: 'Delete booking via booking card',
        copyBookingLink: 'Copy booking link',
        actionViaCreateButton: 'Action Via Create Button',
        spaceViaCreateButton: 'Space Via Create Button',
        bookingPageViaCreateButton: 'Booking Page Via Create Button',
        searchTemplates: 'Search Templates',
        applyTemplate: 'Apply Template',
        starTemplate: 'Star Template',
        starredTemplates: 'Starred Templates',
        allTemplates: 'All Templates',
        myTemplates: 'My Templates',
        confirmBooking: 'Confirm Booking',
        createMeetingViaTeamsAddon: 'Create Meeting via teams add-on',
        selectExistingMeetingViaTeamsAddon:
            'Select Existing Meeting via teams add-on',
    },
    preferences: {
        isSideNavbarCollapsed: 'is-sidepanel-collapsed',
        branding: 'branding',
        isHideDownloadAppModal: 'is-hide-download-app-modal',
        isInMobileApp: 'is-in-mobile-app',
        homePageWidgets: 'home-page-widgets',
    },
    magicValues: {
        inviteUsersLimit: 150,
    },
    signaturesClientSecret: 'e2dedd4a-3f34-4b1f-9495-f6bd97d8ddff',
}

export { constants }
